import React, { ComponentType, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { notFoundPath } from 'common/config/urls';
import { COMPANIES_AVAILABLE_SLUG_PARAMS } from 'common/constants/companies';
import { useStore } from 'common/store';
import { FirmCompany } from 'common/types/company';
import { UseStoreValues } from 'common/types/store/store';

interface CompanyParams extends Record<string, string | undefined> {
  tableSlugParam?: (typeof COMPANIES_AVAILABLE_SLUG_PARAMS)[number];
  companySlugParam?: string;
}

const withCompany = <Props extends object>(WrappedComponent: ComponentType<Props>) =>
  function WithCompany(props: Props) {
    const [{ companyList, companyInfo }] = useStore() as unknown as UseStoreValues;
    const [company, setCompany] = useState<FirmCompany | undefined>();
    const { companySlugParam, tableSlugParam } = useParams<CompanyParams>();
    const navigate = useNavigate();

    useEffect(() => {
      if (companyList?.length && companySlugParam) {
        // search across all companies including child companies
        const allCompanies = [...companyList, ...companyList.flatMap(c => c.child_companies)] as FirmCompany[];
        if (allCompanies) {
          const tmpCompany = allCompanies.find(
            c => c.company_slug === companySlugParam || c.company_id === companyInfo?.id
          );

          setCompany(tmpCompany);
        }
      }
    }, [companyList, companySlugParam, companyInfo]);

    useEffect(() => {
      if (
        (company && isEmpty(company))
        || (tableSlugParam && !COMPANIES_AVAILABLE_SLUG_PARAMS.includes(tableSlugParam))
      ) {
        navigate(notFoundPath);
      }
    }, [company, tableSlugParam, navigate]);

    return <WrappedComponent {...props} />;
  };

export default withCompany;
